import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import mapFacets from 'util/react/facet';
import { Trans } from 'translations';
import ReactPlayer from 'react-player';
import imageDpiResolution from 'util/dom/image-dpi-resolution';
import { connect } from 'react-redux';
import reduxUtils from 'util/redux';
import { VIDEO_AUTOPLAY_DEBOUNCE } from 'constants/debounce-delays';
import PageVisibility from 'components/page-visibility';
import VisibilitySensor from 'components/visibility-sensor';
import { debounce } from 'lodash';


class CardContentLite extends PureComponent {
    static propTypes = {
        mobile_title: PropTypes.string,
        facet: PropTypes.string.isRequired,
        cover_image: PropTypes.object.isRequired,
        cover_video: PropTypes.object,
        videosLoadedAmount: PropTypes.number.isRequired,
        onVideoLoaded: PropTypes.func.isRequired,
        resetVidesoLoaded: PropTypes.func.isRequired,
    };

    state = {
        isVisible: false,
        video: {
            loop: true,
            playing: false,
            controls: false,
            width: '220',
            height: '440',
        },
    };

    componentDidMount() {
        // on iOS we need to force the load event
        // to get the onReady event firing properly
        const videoElement = this.refs.video.getInternalPlayer();
        videoElement.load();
        this.toggle(this.props, true);
    }

    componentWillReceiveProps(newProps) {
        this.toggle(newProps, true);
    }

    componentWillUnmount() {
        this.props.resetVidesoLoaded();
    }

    handleElementVisibility = debounce(function(elVisible) {
        this.toggle(this.props, elVisible);
    }, VIDEO_AUTOPLAY_DEBOUNCE);

    handlePageVisibility = debounce(function(visibilityState, documentHidden) {
        this.toggle(this.props, !documentHidden);
    });

    toggle = (props, isVisible) => {
        this.setState({
            ...this.state,
            isVisible,
            video: {
                ...this.state.video,
                playing: isVisible && this.canPlay(props),
            },
        });
    };

    canPlay = (props) => {
        return props.videosLoadedAmount >= 2;
    };

    render() {
        const { cover_image, facet, mobile_title, cover_video, onVideoLoaded } = this.props;

        return (
            <div className={classnames('card-content-lite', mapFacets(facet, 'card-content-lite'))}>
                <h3 className="card-content-lite--title">{mobile_title}</h3>
                <PageVisibility onChange={this.handlePageVisibility.bind(this)}>
                    <VisibilitySensor onChange={this.handleElementVisibility.bind(this)}>
                        <ReactPlayer
                            ref='video'
                            className="card-content-lite--image"
                            onReady={onVideoLoaded}
                            url={[cover_video.src_webm, cover_video.src]}
                            config={{
                                file: {
                                    attributes: {
                                        poster: cover_image.src[`@${ Math.min(imageDpiResolution(), 2) }`],
                                        autoPlay: this.state.video.playing,
                                        playsInline: true,
                                        muted: true,
                                    },
                                },
                            }}
                            {...this.state.video}
                        />
                    </VisibilitySensor>
                </PageVisibility>
                <Trans path="cards.mobile.more_link" className="card-content-lite--pseudo-link"/>
            </div>
        );
    }
}


export default connect(
    reduxUtils.mapStateToProps({
        videosLoadedAmount: 'video-cards.videosLoadedAmount',
    }),
    reduxUtils.mapDispatchToProps({
        resetVidesoLoaded: 'video-cards.reset',
        onVideoLoaded: 'video-cards.onLoaded',
    }),
)(CardContentLite);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/card-stack/card-content-lite/index.js